// extracted by css-extract-rspack-plugin
module.exports =  {"description":"c1a9dd7bdb","root":"e7f1daf994","breadcrumbs":"f59e9ef129","titleRow":"c5e6e0b8be","title":"b02b1fe028","titleSlot":"af008b9435"};